import ErrorHandler from 'store/utils/ErrorHandler';
import Notify from 'store/utils/Notify';
import fetchSpotlightResults from './api';
import * as types from './actionTypes';

/**
 * Get spotlight results
 *
 * @param params
 */
export const getSpotlightResults = (query = {}) => async dispatch => {
  try {
    await dispatch({
      type: types.GET_SPOTLIGHT_REQUEST,
    });

    const params = {
      ...query,
    };

    const { data } = await fetchSpotlightResults(params);

    await dispatch({
      type: types.GET_SPOTLIGHT_SUCCESS,
      payload: {
        spotlight: data.resources,
        count: data.count,
      },
    });
  } catch (error) {
    await dispatch({
      type: types.GET_SPOTLIGHT_ERROR,
      payload: {
        error: error.message,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

export const resetState = () => ({
  type: types.RESET_STATE,
});
